import { z } from 'zod';

export const inviteStatusSchema = z.enum(['sent', 'used', 'expired']);

export const inviteSchema = z.object({
	id: z.string(),
	key: z.string().optional(),
	email: z.string().trim().toLowerCase().optional(),
	userId: z.string().optional(),
	createdAt: z.date().optional(),
	status: inviteStatusSchema.default('sent'),
	expiresAt: z.date().optional(),
});
